<template>
  <customize-form :schema="schema" ref="form" />
</template>

<script>
export default {
  data() {
    return {
      schema: [
        {
          type: 'input',
          label: 'Query ID',
          key: 'queryId',
          value: this.defaultQuery,
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
      ],
    }
  },
  methods: {
    async validate() {
      const valid = await this.$refs.form.validateFields()
      if (valid) {
        return this.$refs.form.getFormData()
      }
    },
  },
  props: {
    defaultQuery: {
      type: String,
      default: '',
    },
  },
}
</script>
